export default "__VITE_ASSET__b4ff9f72__"